import {WizRequestOptions} from '@/interface';
import {ServerConfig} from '@/config/routers';

import sdk from '.';

async function request(options: WizRequestOptions) {
    const ks = await sdk.getKsServer();
    return ks.request({
        wikiAccessToken: ks.wikiAccessToken,
        ...options,
    });
}

// 新增文档版本
export const createDocEdition = async (versionId: number, docGuid: string, userGuid: string) => {
    // 对外的接口地址改了
    if (window.isTocPage) {
        return request({
            method: 'post',
            url: `${ServerConfig.ku}/doc/external/markDocEdition?docGuid=${docGuid}`,
            data: {versionId, userId: userGuid},
        });
    } else {
        return request({
            method: 'post',
            url: `${ServerConfig.ku}/doc/${docGuid}/edition`,
            data: {versionId, userId: userGuid},
        });
    }
};

// 新增PPT版本
export const createPPTEdition = async (versionId: number, docGuid: string, userGuid: string) => {
    return request({
        method: 'post',
        url: `${ServerConfig.ku}/ppt/${docGuid}/edition`,
        data: {versionId, userGuid},
    });
};


// 重命名PPT版本
export const renamePPTEdition = async (docGuid: string, versionId: number, name: string) => {
    return request({
        method: 'post',
        url: `${ServerConfig.ku}/ppt/version/rename`,
        data: {docGuid, versionId, versionName: name},
    });
};

// 获取PPT最新历史记录
export const getPPTHistoryNewest = async (docGuid: string): Promise<{
    latestVersionId: number;
    latestVersionName: string;
}> => {
    return request({
        method: 'get',
        url: `${ServerConfig.ku}/ppt/version/newest`,
        params: {docGuid},
    });
};

// 获取PPT版本信息
export const getPPTEditionInfo = async (docGuid: string, versioinId: number): Promise<{
    url: string;
    versionId: number;
    versionName: string;
}> => {
    return request({
        method: 'get',
        url: `${ServerConfig.ku}/ppt/${docGuid}/version/${versioinId}`,
    });
};

export interface EditionInfo {
    versionId: number;
    versionName: string;
    editionUrlId: string;
}

// 获取PPT版本列表
export const getPPTEditionList = async (docGuid: string): Promise<{
    editions: EditionInfo[];
}> => {
    return request({
        method: 'get',
        url: `${ServerConfig.ku}/ppt/edition/list`,
        params: {
            docGuid: docGuid,
            page: 1,
            pageSize: 100,
        },
    });
};

// 获取文档版本列表
export const getDocEditionList = async (docGuid: string): Promise<{
    editions: EditionInfo[];
}> => {
    return request({
        method: 'get',
        url: `${ServerConfig.ku}/doc/${docGuid}/edition/list`,
        params: {
            docGuid: docGuid,
            page: 1,
            pageSize: 100,
        },
    });
};

// 解密版本id
export const decodeVersionId = async (editionUrlId: string, docGuid: string): Promise<{
    versionId: number;
    editionId: number;
}> => {
    return request({
        method: 'get',
        url: `${ServerConfig.ku}/util/decode/editionUrl`,
        params: {
            docGuid,
            editionUrlId,
        },
    });
};
